import * as commonScripts from '../common'

const cmpAlert = {
  component: null,
  cookies: commonScripts.util.cookies,

  init: function (element) {
    const _ = this
    _.component = element

    const alertCookie = _.cookies.get('alertCookie')
    const closeBtn = element.querySelector('.cmp-alert__close')

    if (!alertCookie || (alertCookie !== element.dataset.guid)) {
      _.component.classList.add('show-alert')
      commonScripts.util.syncHeaderOffset()
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault()
        _.cookies.set('alertCookie', element.dataset.guid, null, 365)
        _.component.classList.remove('show-alert')
        commonScripts.util.syncHeaderOffset()
      })
    }
  }
}

export default cmpAlert
